import { useEffect, useState } from 'react';
import { getFeatureTogglesService } from '../../services/featureTogglesService';

export const FEATURE_TOGGLE_IDS = {
    FISERV_HOSTED_FIELDS: 1,
};

// null until the toggles arrive, so a form can wait instead of flashing its fallback; a failed fetch falls back to off
export const useFeatureToggle = (featureToggleID) => {
    const [enabled, setEnabled] = useState(null);

    useEffect(() => {
        let active = true;
        (async () => {
            try {
                const { data } = await getFeatureTogglesService();
                if (active) setEnabled(data.some((ft) => ft.id === featureToggleID && !!ft.cpEnabled));
            } catch (error) {
                console.error('useFeatureToggle: failed to fetch feature toggles', error);
                if (active) setEnabled(false);
            }
        })();
        return () => {
            active = false;
        };
    }, [featureToggleID]);

    return enabled;
};
